class RelateProductSlide extends HTMLElement {
  constructor() {
    super();

    this.Slide = this.querySelector('.js-related-product-slide');
    this.swiperRelateProductSlide = new Swiper(this.Slide, {
        slidesPerView: 1,
        spaceBetween: 0,
        autoHeight: false,
        centeredSlides: false,
        pagination: {
          el: ".swiper-pagination-custom",
          clickable: true,
        },
        // Navigation arrows
        navigation: {
          nextEl: '.swiper-button-next-custom',
          prevEl: '.swiper-button-prev-custom',
        },
        breakpoints: {
          749: {
            slidesPerView: 2,
            spaceBetween: 40,
          },
          989: {
            slidesPerView: 3,
            spaceBetween: 40,
          },
          1280: {
            slidesPerView: 4,
            spaceBetween: 30,
          },
        },
    });
  }
}
customElements.define("related-product-slide", RelateProductSlide);